import React from 'react'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import { Input, Icon } from 'loyal-react'
import PasswordStrength from '../PasswordStrength/PasswordStrength'
import MediaQuery from 'react-responsive'

const toSeconds = (seconds) => {
  return [parseInt((seconds / 60) % 60), parseInt(seconds % 60)].join(':').replace(/\b(\d)\b/g, '0$1')
}

const BoxNewPassword = ({
  password,
  passwordConfirmation,
  isSendingConfirmation,
  isEnableToken,
  timeLeft,
  handleChange,
  handleSubmit,
  handleSendCode,
  code,
  email,
  passwordError,
  error,
  location: { search }
}) => {
  const isPasswordsMatch = passwordConfirmation === password
  const isValid = password && passwordConfirmation && password === passwordConfirmation
  return (
    <div id='box-newPassword' className='box-login box-newPassword row pb-4'>
      <div className='col-12 col-md-6 col-lg-4 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5'>
        <div className='row'>
          <div className='col-6 col-md-12 d-block d-md-none back-button mb-2'>
            <p className='txt-body-sm'>
              <MediaQuery maxWidth={489}>
                <a
                  id='image-link'
                  href={`/login${search}`}
                  className='txt-body-sm d-block'
                  tabIndex='1'
                  aria-label='Voltar'
                  role='button'
                >
                  <Icon className='icon icon_left_app color-ui-white txt-body-lg txt-body-sm d-block' />
                </a>
              </MediaQuery>
              <MediaQuery minWidth={490}>
                <a
                  href={`/login${search}`}
                  className='txt-body-sm d-block'
                  tabIndex='1'
                  aria-label='Voltar'
                  role='button'
                >
                  <Icon className='icon icon_left_app color-ui-white txt-body-lg txt-body-sm d-block' />
                </a>
              </MediaQuery>
            </p>
          </div>
          <MediaQuery maxWidth={489}>
            <div className='col-6 mb-2 close-login'>
              <p className='txt-body-sm'>
                <a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}`} className='txt-body-sm d-flex justify-content-end' aria-label='Fechar tela de login' role='button'>
                  <Icon className='icon icon_menu_app_close' />
                </a>
              </p>
            </div>
          </MediaQuery>
          <div className='col-12 mb-2 d-none d-md-block'>
            <p className='txt-body-sm'>
              <a href={`/login${search}`} className='txt-body-sm' aria-label='Voltar' role='button'>
                <Icon className='icon icon_left_app' />
              </a>
            </p>
          </div>
          <div className='col-12'>
            <h1 className='h1 login-title color-brand-1 txt-font-body mb-1'>Nova senha</h1>
            <p className='txt-body-sm'>
              Enviamos um código de 6 digitos para o email <strong>{email}</strong>.
            </p>
            <p className='txt-body-sm mb-1'>Por favor, digite o código no campo:</p>
            <div className='row'>
              <Input
                id='documento'
                name='code'
                label='Código de Confirmação'
                className='col-12 col-md-12 mt-1'
                onChange={handleChange}
                value={code}
                valid={error ? false : undefined}
                data-error={error && error.message}
                mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]}
              />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <p className='txt-body-sm mb-1'>E agora, digite e confirme sua nova senha.</p>
            <div className='row'>
              <Input
                id='password'
                label='Nova Senha'
                className='col-12 col-md-12 mt-1'
                name='password'
                value={password}
                onChange={handleChange}
                type='password'
                valid={passwordError ? false : undefined}
                data-error={passwordError && passwordError.message}
              />
              <Input
                id='passwordConfirmation'
                label='Confirme Senha'
                className='col-12 col-md-12 mt-2'
                name='passwordConfirmation'
                value={passwordConfirmation}
                onChange={handleChange}
                type='password'
                valid={passwordConfirmation && !isPasswordsMatch ? false : undefined}
                data-error='As senhas digitadas não conferem'
              />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <PasswordStrength password={password} />
          </div>
        </div>
        <div className='col-12 col-md-12 txt-center mt-2 px-0'>
          <button className='txt-bold btn btn-sm' disabled={!isEnableToken} onClick={handleSendCode}>
            {`${!isEnableToken ? 'Reenviar em 00:' + toSeconds(timeLeft) : 'Reenviar Token'}`}
          </button>
        </div>
        <div className='col-12 col-md-12 txt-center mt-2 px-0'>
          <button
            disabled={!isValid || isSendingConfirmation}
            onClick={handleSubmit}
            className='btn btn-sm btn-featured'
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  )
}

BoxNewPassword.propTypes = {
  isEnableToken: PropTypes.bool,
  password: PropTypes.string,
  passwordConfirmation: PropTypes.string,
  isSendingConfirmation: PropTypes.bool,
  timeLeft: PropTypes.string,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleSendCode: PropTypes.func,
  code: PropTypes.string,
  email: PropTypes.string,
  passwordError: PropTypes.object,
  error: PropTypes.object,
  location: PropTypes.shape({
    search: PropTypes.string
  })
}

export default withRouter(BoxNewPassword)
